import {AppLayout} from "src/features/client";
import {Box} from "@mantine/core";
import {ContactsWidget} from "src/widgets/client/contacts";
import {CategoriesWidget} from "src/widgets";
import {Helmet} from "react-helmet";
import {generateMetaData} from "src/shared/config/seo/meta-data";
import {useTranslation} from "react-i18next";

export function ContactsPage() {
    const {t} = useTranslation();

    const metaData = generateMetaData(
        t("seo.title.contacts"),
        t("seo.description.contacts"),
        "/contacts"
    );

    return (
        <AppLayout>
            <Helmet>
                <title>{metaData.title}</title>
                {metaData.description && <meta name="description" content={metaData.description}/>}
                {metaData.openGraph && (
                    <meta property="og:title" content={metaData.openGraph.title}/>
                )}
                {metaData.openGraph && (
                    <meta property="og:description" content={metaData.openGraph.description}/>
                )}
                {metaData.openGraph && (
                    <meta property="og:image" content={metaData.openGraph.images}/>
                )}
                {metaData.openGraph && (
                    <meta property="og:url" content={metaData.openGraph.url}/>
                )}
                {metaData.twitter && (
                    <meta name="twitter:card" content={metaData.twitter.card}/>
                )}
                {metaData.twitter && (
                    <meta name="twitter:title" content={metaData.twitter.title}/>
                )}
                {metaData.twitter && (
                    <meta name="twitter:description" content={metaData.twitter.description}/>
                )}
                {metaData.twitter && (
                    <meta name="twitter:image" content={metaData.twitter.images}/>
                )}
            </Helmet>
            <Box className="container">
                <ContactsWidget/>
            </Box>
            <CategoriesWidget/>
        </AppLayout >
    );
}
